/**
 * @providesModule BlockedUsersStore
 * 
 * Provides an intermediary to check for blocked users via ID instead of JID
 */

import _ from 'lodash';
import MinFlux from 'min-flux';

export default new MinFlux.Store({
  blockedUsers: [],

  getBlockedUsers(): Array<String> {
    return this.blockedUsers.slice();
  },


  isUserBlocked(userId: String): Boolean {
    return _.includes(this.blockedUsers, userId.toString());
  },

  updateBlockedUsers(userJids: Array<String>) {
    this.blockedUsers = _.map(userJids, (userJid: String): String => {
      return this._getIDFromJid(userJid);
    });
    console.debug('BlockedUsersStore: updated blocked users: ' + JSON.stringify(this.blockedUsers));
  },

  _getIDFromJid(userJid: string): string {
    const splitArray = userJid.toString().split("@");
    return _.first(splitArray);
  },
});
